// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"_39l1B","language":"d7FcY","languagesDropdown":"_2k2JA","userLanguage":"vcYGW","outline":"ETJaL","icon":"_1gYRP","world":"GUlaE","pickDown":"sB7ax"};